import { Spinner, Text } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';

export const ReconsentLoading = () => {
    return (
        <div className="flex flex-col items-center gap-m py-xl">
            <Spinner size="large" />
            <Text size="s">
                <FormattedMessage
                    id="_.bank_selection_modal.reconsent.loading"
                    defaultMessage="Just a moment while we sort this out..."
                />
            </Text>
        </div>
    );
};
